import contentTypes from 'config/types/content';
import taxonomies from 'config/types/taxonomy';

export const FRENCH = 'fr';
export const ENGLISH = 'en';
// British english is currently in use only for in-product magazine
// see docs/in-product-locale.md for more information
export const ENGLISH_BRITISH = 'en_GB';
export const ENGLISH_USA = 'en-US';
export const GERMAN = 'de';
export const ITALIAN = 'it';
export const SPANISH = 'es';
export const POLISH = 'pl';
export const PORTUGUESE = 'pt';
export const SWEDISH = 'sv';

export const defaultLanguage = ENGLISH;

export const languageCodePostTypeMap = {
  [ENGLISH]: contentTypes.POST,
  [ENGLISH_USA]: contentTypes.POST,
  [FRENCH]: contentTypes.FRENCH,
  [GERMAN]: contentTypes.GERMAN,
  [ITALIAN]: contentTypes.ITALIAN,
  [SPANISH]: contentTypes.SPANISH,
  [POLISH]: contentTypes.POLISH,
  [PORTUGUESE]: contentTypes.PORTUGUESE,
  [SWEDISH]: contentTypes.SWEDISH,
};

export const languageCodePostTypeWithEnglishMap = {
  ...languageCodePostTypeMap,
  [ENGLISH]: 'english_edition',
  [ENGLISH_USA]: 'english_USA_edition',
};

export const languageCodeTagTaxonomyMap = {
  [ENGLISH]: taxonomies.ENGLISH_TAGS,
  [ENGLISH_USA]: taxonomies.ENGLISH_TAGS,
  [FRENCH]: taxonomies.FRENCH_TAGS,
  [GERMAN]: taxonomies.GERMAN_TAGS,
  [ITALIAN]: taxonomies.ITALIAN_TAGS,
  [SPANISH]: taxonomies.SPANISH_TAGS,
  [POLISH]: taxonomies.POLISH_TAGS,
  [PORTUGUESE]: taxonomies.PORTUGUESE_TAGS,
  [SWEDISH]: taxonomies.SWEDISH_TAGS,
};

export const languageCodeCategoryTaxonomyMap = {
  [ENGLISH]: taxonomies.ENGLISH_CATEGORIES,
  [ENGLISH_USA]: taxonomies.ENGLISH_CATEGORIES,
  [FRENCH]: taxonomies.FRENCH_CATEGORIES,
  [GERMAN]: taxonomies.GERMAN_CATEGORIES,
  [ITALIAN]: taxonomies.ITALIAN_CATEGORIES,
  [SPANISH]: taxonomies.SPANISH_CATEGORIES,
  [POLISH]: taxonomies.POLISH_CATEGORIES,
  [PORTUGUESE]: taxonomies.PORTUGUESE_CATEGORIES,
  [SWEDISH]: taxonomies.SWEDISH_CATEGORIES,
};

export const languageCodesArray = [
  FRENCH,
  GERMAN,
  ENGLISH,
  ENGLISH_USA,
  ITALIAN,
  SPANISH,
  POLISH,
  PORTUGUESE,
  SWEDISH,
];

export const languageCodeEnglishFullNames = {
  [ENGLISH]: 'English',
  [ENGLISH_USA]: 'English',
  [FRENCH]: 'French',
  [GERMAN]: 'German',
  [ITALIAN]: 'Italian',
  [SPANISH]: 'Spanish',
  [POLISH]: 'Polish',
  [PORTUGUESE]: 'Portuguese',
  [SWEDISH]: 'Swedish',
};

export const englishAlternatives = [ENGLISH_BRITISH, ENGLISH_USA];

export default {
  FRENCH,
  GERMAN,
  ENGLISH,
  ENGLISH_BRITISH,
  ENGLISH_USA,
  ITALIAN,
  SPANISH,
  POLISH,
  PORTUGUESE,
  SWEDISH,
};
